import { useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { STORAGE_KEYS } from 'constants/enums';
import routes from 'constants/routes';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import useToggle from 'hooks/useToggle';
import i18n from 'i18n/config';
import { getUserId } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import { CircularLockIcon } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';
import MaterialConfirmDialog from 'UIKit/MaterialConfirmDialog';

import styles from './setup2fa.module.scss';

const textMandatory2FASetupRequired = i18n.t('common:mandatory2FASetupRequired');
const textMandatory2FADescription = i18n.t('common:mandatory2FADescription');
const textSetup2FA = i18n.t('common:setup2FA');

const Setup2faModal = () => {
  const [open, toggleOpen] = useToggle(false);
  const userId = useAppSelector(getUserId);

  const history = useHistory();

  const { whenBelowMd } = useCustomMediaQuery();

  useEffect(() => {
    if (userId === undefined) {
      return;
    }
    const value = localStorage.getItem(STORAGE_KEYS.USER_ID_POST_2FA_RESET);

    if (value !== null && Number(value) === userId) {
      toggleOpen();
    } else if (value !== null) {
      // if user logged out from another account remove key
      localStorage.removeItem(STORAGE_KEYS.USER_ID_POST_2FA_RESET);
    }
  }, [toggleOpen, userId]);

  const handleSetup2fa = () => {
    localStorage.removeItem(STORAGE_KEYS.USER_ID_POST_2FA_RESET);
    toggleOpen();
    history.push(routes.account.security.twofa.enable_2fa);
  };

  const handleClose = () => {
    localStorage.removeItem(STORAGE_KEYS.USER_ID_POST_2FA_RESET);
    toggleOpen();
  };

  return (
    <MaterialConfirmDialog
      showFooter={false}
      open={open}
      title=""
      onClose={handleClose}
      testId="mandatory-setup-2fa-modal"
      fullWidth={whenBelowMd}
      containerClassName={styles.container}
    >
      <Box className={styles.body}>
        <Box className={styles.icon}>
          <CircularLockIcon color="var(--secondaryText)" />
        </Box>
        <Box className={styles.heading}>{textMandatory2FASetupRequired}</Box>
        <Box className={styles.message}>{textMandatory2FADescription}</Box>
        <DeltaButton
          data-testid="setup-2fa-button"
          text={textSetup2FA}
          className={styles.setup2faButton}
          onClick={handleSetup2fa}
        />
      </Box>
    </MaterialConfirmDialog>
  );
};

export { Setup2faModal };
